import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import EmailVerified from './views/EmailVerified.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/email-verify',
      name: 'emailVerified',
      // component: () => import(/* webpackChunkName: "email" */ './views/EmailVerified.vue'),
      component: EmailVerified,
      props: (route) => ({
        email: route.query.email,
        success: route.query.success === 'true',
        message: route.query.message
      })
    },
    // Catch-all to redirect back to front page has to go last...
    {
      path: '*',
      redirect: '/'
    }
  ]
})
